import styled from 'styled-components'

export const GruberContainer = styled.div`
	display: flex;
	gap: 20px;
	align-items: flex-start;
	width: 100%;
`

export const GruberTableWrapper = styled.div`
	flex: 1;
	min-width: 0;
	overflow: auto;
`

export const GruberPanel = styled.div`
	width: 384px;
	flex-shrink: 0;
`

export const GruberPanelTitle = styled.h4`
	margin-bottom: 16px;
	font-weight: 600;
`

export const GruberPanelButtons = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 16px;
`

/* Match add button size (add.svg: 20px) */
const ACTION_ICON_SIZE = 20

export const StyledShopTimeSlot = styled.div`
	& .rt-tr .rt-th, .rt-tr-group .rt-tr-group .rt-tr .rt-td{
        width: auto !important;
        flex: 0 0 130px !important;
        &:nth-child(5){
            flex: 0 0 153px !important;
        }
        &:nth-child(6){
            flex: 1 1 153px !important;
        }
        &:last-child{
            flex: 0 0 auto !important;
            min-width: 70px;
        }
    }
	/* Action column: align icons with add button, consistent right padding */
	& .rt-tr-group .rt-tr .rt-td:last-child,
	& .rt-tr-group .rt-tr-group .rt-tr .rt-td:last-child {
		display: flex !important;
		align-items: center;
		justify-content: flex-end;
		padding-right: 8px;
	}
	/* Edit and delete icons - same size as add button, visible only on row hover */
	& .rt-td:last-child svg,
	& .rt-th:last-child svg {
		width: ${ACTION_ICON_SIZE}px !important;
		height: ${ACTION_ICON_SIZE}px !important;
		min-width: ${ACTION_ICON_SIZE}px;
		min-height: ${ACTION_ICON_SIZE}px;
		cursor: pointer;
	}
	& .rt-td:last-child [class*="btn-edit"],
	& .rt-td:last-child [class*="btn-del"] {
		visibility: hidden;
	}
	& .rt-tr:hover .rt-td:last-child [class*="btn-edit"],
	& .rt-tr:hover .rt-td:last-child [class*="btn-del"] {
		visibility: visible !important;
	}
`

